import { render } from "./GradeV2Process.vue?vue&type=template&id=538e21b0&scoped=true&ts=true&lang=pug"
import script from "./GradeV2Process.vue?vue&type=script&lang=ts"
export * from "./GradeV2Process.vue?vue&type=script&lang=ts"

import "./GradeV2Process.vue?vue&type=style&index=0&id=538e21b0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-538e21b0"]])

export default __exports__